import * as React from 'react';

import type { WosIconProps } from 'types/common_types';

function custom(props: WosIconProps) {
  const { className } = props;

  return (
    <svg viewBox="0 0 79 60" className={className}>
      <path
        fill="currentColor"
        d="M54.084 39.758l-10.4-17.337v-7.032h1.053c0.581 0 1.053-0.471 1.053-1.053s-0.471-1.053-1.053-1.053v0h-10.526c-0.581 0-1.053 0.471-1.053 1.053s0.471 1.053 1.053 1.053v0h1.053v7.032l-10.4 17.337c-2.379 3.968-0.547 7.221 4.084 7.221h21.053c4.632 0 6.474-3.253 4.084-7.221zM30.526 34.347l6.842-11.347v-7.6h4.211v7.6l6.842 11.347h-17.895z"
      />
      <path
        fill="currentColor"
        d="M77.368 60.137h-75.789c-0.872 0-1.579-0.707-1.579-1.579v0-56.842c0-0.872 0.707-1.579 1.579-1.579v0h75.789c0.872 0 1.579 0.707 1.579 1.579v0 56.842c0 0.872-0.707 1.579-1.579 1.579v0zM3.158 56.979h72.632v-53.684h-72.632z"
      />
    </svg>
  );
}

export default custom;
